import { FilterGroupingEnum } from 'graphql-common';
import {
  GetLoadOptions,
  LoadOptions,
  SelectOption,
} from '@lib/components/Select/types';

export const getLoadOptionsWithSelectedFilter = (
  getLoadOptions: (filters?: Array<Record<string, unknown>>) => LoadOptions,
  getAdditionalFilters?: (
    values?: Record<string, SelectOption[]>,
  ) => Array<Record<string, unknown>>,
): GetLoadOptions => {
  return (name, values) => {
    const isSelectedTab = name.endsWith('-selected');
    const filters: Array<Record<string, unknown>> = [];

    // Extract the actual field name (remove '-selected' suffix if present)
    const fieldName = isSelectedTab ? name.replace('-selected', '') : name;

    // values is always an object like {sectors: [], sites: [], ...}
    const valuesObj = (values || {}) as Record<string, SelectOption[]>;

    if (getAdditionalFilters) {
      filters.push(...getAdditionalFilters(valuesObj));
    }

    // For selected tabs, filter by the selected items
    if (isSelectedTab) {
      const fieldValues = valuesObj[fieldName];
      if (fieldValues && Array.isArray(fieldValues) && fieldValues.length > 0) {
        const ids = fieldValues.map(({ value }) => value) as string[];
        filters.push({
          id: {
            grouping: FilterGroupingEnum.And,
            predicate: { in: ids },
            filterGroup: 'id',
          },
        });
      }
    }

    return getLoadOptions(filters.length ? filters : undefined);
  };
};

// `getAdditionalFilters` narrowing one filter's options to the ids picked in
// another field of the same filter row, e.g. Sites by the selected Sectors:
// `filterBySelectedIds('sectors', 'sectorId')`.
export const filterBySelectedIds =
  (fieldName: string, filterKey: string) =>
  (values?: Record<string, SelectOption[]>): Array<Record<string, unknown>> => {
    const ids = (values?.[fieldName] || []).map(({ value }) => value);
    if (!ids.length) return [];
    return [
      {
        [filterKey]: {
          grouping: FilterGroupingEnum.And,
          predicate: { in: ids },
          filterGroup: filterKey,
        },
      },
    ];
  };
